import { createRoute, type AnyRoute } from '@tanstack/react-router'
import AdminUsersPage from './pages/AdminUsersPage'
import ConfirmEmailPage from './pages/ConfirmEmailPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage'
import LoginPage from './pages/LoginPage'
import MfaPage from './pages/MfaPage'
import PasswordSetupPage from './pages/PasswordSetupPage'
import ProfilePage from './pages/ProfilePage'
import RegisterPage from './pages/RegisterPage'
import ResetPasswordPage from './pages/ResetPasswordPage'

interface EmailLinkSearch {
  userId: string
  token: string
}

const readEmailLink = (search: Record<string, unknown>): EmailLinkSearch => ({
  userId: typeof search.userId === 'string' ? search.userId : '',
  token: typeof search.token === 'string' ? search.token : '',
})

// /confirm-email et /reset-password sont figes : les workers les ecrivent dans
// les e-mails (AccountLinks), les renommer casse les liens deja envoyes.
export function createCommonsRoutes<TParent extends AnyRoute>(parent: TParent) {
  return [
    createRoute({
      getParentRoute: () => parent,
      path: '/login',
      // `?expired=true` : arrivee apres une deconnexion pour inactivite.
      validateSearch: (search: Record<string, unknown>): { expired?: boolean } =>
        search.expired === true || search.expired === 'true' ? { expired: true } : {},
      component: LoginPage,
    }),
    createRoute({ getParentRoute: () => parent, path: '/register', component: RegisterPage }),
    createRoute({ getParentRoute: () => parent, path: '/mfa', component: MfaPage }),
    createRoute({ getParentRoute: () => parent, path: '/password/setup', component: PasswordSetupPage }),
    createRoute({ getParentRoute: () => parent, path: '/forgot-password', component: ForgotPasswordPage }),
    createRoute({
      getParentRoute: () => parent,
      path: '/confirm-email',
      validateSearch: readEmailLink,
      component: ConfirmEmailPage,
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/reset-password',
      validateSearch: readEmailLink,
      component: ResetPasswordPage,
    }),
    createRoute({ getParentRoute: () => parent, path: '/profile', component: ProfilePage }),
    createRoute({ getParentRoute: () => parent, path: '/admin/users', component: AdminUsersPage }),
  ] as const
}
